








































import Vue from 'vue'
import TopPageArticle from '@/top/components/TopPageArticle.vue'
import TopPageNotice from '@/top/components/TopPageNotice.vue'
import TopPageFeatured from '@/top/components/TopPageFeatured.vue'
import TopPageNovelty from '@/top/components/TopPageNovelty.vue'
import TopPageFaq from '@/top/components/TopPageFaq.vue'
import SearchControl from '@/top/components/SearchControl.vue'
import TopPageProduct from '@/top/components/TopPageProduct.vue'
import BrandsProduct from '@/top/components/BrandsProduct.vue'
import FacetsLink from '@/common/components/facets/FacetsLink.vue'
import { Article, TopProducts, TopProductItem } from '@/top/types'
import { MaxQuantityPrice } from '@/common/types/maxQuantityPrice'
import { Announcement } from '@/common/types/announcements'
import { BQ_AWS_PERSONALIZE_LOGIC_TYPE, BQ_AWS_PERSONALIZE_PAGE_TYPE, BQ_EVENT_NAMES, raksulBQEventTracker} from '@/common/utils'
import { apolloClient } from '@/common/service/apolloClient'
import { recommendedProductsQuery } from '@/product/queries'
import { ProductType } from '@/types'
import { captureMessage } from '@sentry/browser'
import { PERSONALIZE_AREAS, PERSONALIZE_PAGES, PERSONALIZE_PATTERNS } from '@/common/const'

interface Observer {
  root: Element | Document | null;
  rootMargin: string;
  thresholds: ReadonlyArray<number>;
  disconnect(): void;
  observe(target: Element): void;
  unobserve(target: Element): void;
}
export default Vue.extend({
  name: 'TopPageMain',
  components: {
    TopPageNotice,
    TopPageFeatured,
    TopPageArticle,
    TopPageNovelty,
    TopPageFaq,
    SearchControl,
    TopPageProduct,
    BrandsProduct,
    FacetsLink
  },
  props: {
    productCategories: {
      type: Array,
      required: true
    },
    articlesData: {
      type: Array as () => Article[],
      required: true
    },
    announcementsData: {
      type: Array as () => Announcement[],
      required: true
    },
    maxQuantityPrice: {
      type: Object as () => MaxQuantityPrice,
      required: true
    },
    flagTopSearch: {
      type: Boolean,
      required: true
    },
    historyProducts: {
      type: Array as () => TopProductItem[],
      required: true
    },
    topProducts: {
      type: Array as () => TopProducts[],
      required: true
    }
  },
  data(): {
    trackProductIds: Array<number>,
    calcTimeInterval: number | null,
    observerHandler: Observer | null
    showRecommendation: boolean,
    recommendedProducts: Array<ProductType>,
  }{
    return {
      trackProductIds: [],
      calcTimeInterval: null,
      observerHandler: null,
      showRecommendation: false,
      recommendedProducts: []
    }
  },
  computed: {
    noticeInfo(): Announcement[] {
      return this.announcementsData.filter(item => {
        return item.announcement_type === 'info'
      })
    },
    transformedPersonalizeProducts(): Array<ProductType> {
      return this.recommendedProducts.map(item => {
        return {
          ...item,
          minProductPrice: item.minPrice,
          maxProductPrice: item.maxPrice
        }
      })
    }
  },
  watch: {
    trackProductIds(value) {
      this.clearTrackingInterval()
      if (value.length) this.trackingInterval()
    }
  },
  created() {
    this.getPersonalizeProducts()
    window.triggerShowRecommendation = () => {
      this.showRecommendation = true
      this.trackPersonalize()
    }
  },
  mounted() {
    window.addEventListener('load', () => {
      this.createIntersectionObserver()
    })

    window.addEventListener('beforeunload', () => {
      this.clearTrackingInterval()
      this.observerHandler?.disconnect()
      this.checkTrackProductIds()
    })

    // Check if Karte loaded and has variable window.isKarteLoaded=true
    if (window.isKarteLoaded === true) {
      this.showRecommendation = true
      this.trackPersonalize()
    } else {
      // Karte haven't load yet. Set to window.isKarteLoaded=false
      window.isKarteLoaded = false
    }
  },
  methods: {
    async getPersonalizeProducts() {
      const numberOfProducts = 12
      await apolloClient
        .query({
          query: recommendedProductsQuery,
          variables: {
            offset: 0,
            limit: numberOfProducts,
            awsPersonalize: {
              numResults: numberOfProducts,
              pattern: PERSONALIZE_PATTERNS.PATTERN_A,
              pageType: PERSONALIZE_PAGES.TOP,
              pageArea: PERSONALIZE_AREAS.DEFAULT
            }
          }
        })
        .then(response => {
          this.recommendedProducts = response.data?.recommendedProducts.items
        })
        .catch(error => {
          captureMessage(`Failed to aws personalize products ${error}`)
        })
    },
    createIntersectionObserver() {
      const intersectOptions = {
        root: null,
        threshold: 1.0
      }
      this.observerHandler = new IntersectionObserver(this.intersectCallback, intersectOptions)
      const targetElements = document.querySelectorAll('.tp-ProductCard')
      targetElements.forEach(targetElement => {
        this.observerHandler?.observe(targetElement)
      })
    },
    //@ts-ignore
    intersectCallback(entries, observer) {
      entries.forEach((entry: any) => {
        if (entry.isIntersecting) {
          const targetProductId = entry.target.dataset.productId
          this.trackProductIds.push(targetProductId)
          observer.unobserve(entry.target)
        }
      })
    },
    checkTrackProductIds() {
      if (this.trackProductIds.length) {
        this.trackingProductView()
      }
    },
    trackingProductView() {
      const formatTrackProductIds = JSON.stringify(this.trackProductIds)
      raksulBQEventTracker({
        eventName: BQ_EVENT_NAMES.VIEW_MERCHANDISE,
        data: {
          productIds: formatTrackProductIds
        }
      })
      this.trackProductIds = []
    },
    trackingInterval() {
      this.calcTimeInterval = window.setInterval(() => {
        this.checkTrackProductIds()
      }, 2000)
    },
    clearTrackingInterval() {
      clearInterval(this.calcTimeInterval!)
    },
    trackPersonalize() {
      window.isKarteEventTriggered = true
      raksulBQEventTracker({
        eventName: BQ_EVENT_NAMES.VIEW_AWS_PERSONALIZE,
        data: {
          recommendationLogic: BQ_AWS_PERSONALIZE_LOGIC_TYPE.RECOMMENDED_FOR_YOU,
          pageType: BQ_AWS_PERSONALIZE_PAGE_TYPE.TOP_PAGE
        }
      })
    }
  }
})
